import { defa }    from 'defa-object';
import Root        from 'scripts/defa/application/view-root-view';
import ErrorView   from 'scripts/defa/basic/view-error-view';
import SuccessView from 'scripts/defa/basic/view-success-view';
import Service     from 'scripts/poppet/service';

const channelNav  = Bb.Radio.channel( 'nav' ),
	channelUser = Bb.Radio.channel( 'user' );

const selectors = {
	application : '[data-application=defa]',
	btnInstalled: '[data-click=show-installed]',
};

/**
 * defa.services.LayoutHandler
 * A handler for setting and removing all kinds of changes to the layout.
 * !TODO: Liberate the support button and support frame from /support/ and let it be controlled from the LayoutHandler
 * @version 1.1.9
 */
const LayoutHandler = Service.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	channelName: 'layout',
	
	radioEvents: {
		'error'     : 'onError',
		'success'   : 'onSuccess',
		'idle'      : 'blurAll',
		'init'      : 'setInit',
		'menu:hide' : 'hideMenu',
		'menu:show' : 'showMenu',
	},
	
	radioRequests: {
		'is:native': 'isNative',
		'is:toyota': 'isToyota',
		'has:login': 'hasLogin',
		'root'     : 'getRoot',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * @constructor
	 */
	initialize: function ( options ) {
		this.options = options || {};
		
		this._checkToyota();
		this._checkNative();
		
		this.listenTo( channelUser, 'user:change:bluetooth', this.onUserChangeBluetooth );
		this.listenTo( channelUser, 'user:change:logged', this.onUserChangeLogged );
		
	},
	
	/**
	 * Triggers when the layout channel triggers an error event.
	 * @void
	 */
	onError: function ( options ) {
		this.getRoot().showChildView( 'main', new ErrorView( options ) );
	},
	
	/**
	 * Triggers when the layout channel triggers an success event.
	 * @void
	 */
	onSuccess: function( options ){
		let successView = new SuccessView(options);
		
		this.listenToOnce( successView, 'success:close', function () {
			successView.animateOut();
		} );
		this.getRoot().showChildView('main', successView);
	},
	
	/**
	 * Triggers when the user changes it's has:bluetooth state.
	 * @void
	 */
	onUserChangeBluetooth: function () {
		
		if ( channelUser.request( 'has:bluetooth' ) ) {
			$( selectors.application ).attr( 'data-has-bluetooth-device', true );
		} else {
			$( selectors.application ).removeAttr( 'data-has-bluetooth-device' );
		}
	},
	
	/**
	 * Triggers when the user changes it's login state.
	 * @void
	 */
	onUserChangeLogged: function () {
		
		// set datasets
		this._setApplicationDatasets();
		
		// installer button
		if ( $( selectors.application ).attr( 'data-installer' ) ) {
			$( selectors.btnInstalled ).on( 'click', function ( event ) {
				event.preventDefault();
				channelNav.trigger( 'unit:installed:select' );
			} );
		}
		
		
		// support button
		
		// support frame
		
		// initialize
		$( selectors.application ).attr( 'data-init', true );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	/**
	 * Hides both #top and #bottom elements.
	 * @void
	 */
	hideMenu: function() {
		$( 'body' ).addClass( 'terms-accepted' );
	},
	
	/**
	 * Shows both #top and #bottom elements.
	 * @void
	 */
	showMenu: function() {
		$( 'body' ).removeClass( 'terms-accepted' );
	},
	
	/**
	 * Sets the data-init variable, signaling elements we're ready to play.
	 * @void
	 */
	setInit: function () {
		$( selectors.application ).attr( 'data-init', true );
	},
	
	
	/**
	 * Attempts to blur all elements.
	 * @void
	 */
	blurAll: function () {
		$( document.activeElement ).blur();
	},
	
	/**
	 * Checks if the app is currently in native state.
	 * @return {bool}  True if the app is in a native state, false if not.
	 */
	isNative: function () {
		if ( window.isNative ) {
			return true;
		} else {
			return ( !_.isUndefined( defa.vars.android ) || !_.isUndefined( defa.vars.webkit ) );
		}
	},
	
	/**
	 * Checks if the app is currently in toyota state.
	 * @return {bool}  True if the app is in the toyota state, false if not.
	 */
	isToyota: function () {
		return ! _.isUndefined( defa.vars.toyota );
	},

	/**
	* Checks if the app supports log-in
	* @return {bool} True if the app supports log-in, false if not
	*/
	hasLogin: function() {
		return !this.isToyota();
	},
	
	/**
	 * Gets the root view of the app.
	 * @return {view}  The root view of the app.
	 */
	getRoot: function () {
		
		if ( !this.root ) {
			this.root = new Root();
		}
		
		return this.root;
	},
	
	/**
	 * Checks for toyota variables and sets the app up accordingly.
	 * @void
	 */
	_checkToyota: function () {
		
		if ( defa.vars.toyota ) {
			$( selectors.application )
				.attr( 'data-toyota', true )
				.attr( 'data-offline', true );
		}
	},
	
	/**
	 * Checks for native variables and sets the app up accordingly.
	 * @void
	 */
	_checkNative: function () {
		
		if ( this.isNative() ) {
			$( selectors.application ).attr( 'data-native', true );
		}
	},
	
	/**
	 * Sets lots of application datasets based on application state.
	 * @void
	 */
	_setApplicationDatasets: function () {
		
		let user = channelUser.request( 'model' );
		
		if ( channelUser.request( 'is:logged:in' ) ) {
			$( selectors.application ).attr( 'data-logged-in', true );
		} else {
			$( selectors.application ).removeAttr( 'data-logged-in' );
		}
		
		if ( user.hasRoles( [ 'ALARM_CENTRAL' ] ) ) {
			$( selectors.application ).attr( 'data-acp', true );
		} else {
			$( selectors.application ).removeAttr( 'data-acp' );
		}
		
		if ( user.hasRoles( [ 'TECHNICAL_SUPPORT' ] ) ) {
			$( selectors.application ).attr( 'data-tsp', true );
		} else {
			$( selectors.application ).removeAttr( 'data-tsp' );
		}
		
		if ( user.hasRoles( [ 'INSTALLER_AUTOMOTIVE_DT' ] ) ) {
			$( selectors.application ).attr( 'data-dtp', true );
		} else {
			$( selectors.application ).removeAttr( 'data-dtp' );
		}
		
		if ( user.hasRoles( [ 'INSTALLER_AUTOMOTIVE' ] ) ) {
			$( selectors.application ).attr( 'data-automotive', true );
		} else {
			$( selectors.application ).removeAttr( 'data-automotive' );
		}
		
		if ( user.hasRoles( [ 'INSTALLER_HOME' ] ) ) {
			$( selectors.application ).attr( 'data-home', true );
		} else {
			$( selectors.application ).removeAttr( 'data-home' );
		}
		
		if ( user.hasRoles( [ 'INSTALLER_AUTOMOTIVE', 'INSTALLER_HOME', ] ) && !user.hasRoles( [ 'TECHNICAL_SUPPORT', ] ) ) {
			$( selectors.application ).attr( 'data-installer', true );
		} else {
			$( selectors.application ).removeAttr( 'data-installer' );
		}
		
		if ( user.hasRoles( [ 'INSTALLER_HOME', 'INSTALLER_AUTOMOTIVE', 'INSTALLER_AUTOMOTIVE_DT', 'TECHNICAL_SUPPORT', 'ALARM_CENTRAL', ] ) ) {
			$( selectors.application ).attr( 'data-roles', true );
		} else {
			$( selectors.application ).removeAttr( 'data-roles' );
		}
		
	},
	
} );

export default LayoutHandler;